export interface DocumentTypeLookup {
    passport: string;
    national: string;
    driver: string;
    bank: string;
}
